import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as AuthActions from '../../ngrx/auth/auth.actions';
import { LoadingService } from '../../services/loading/loading.service';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth/auth.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  constructor(
    private store: Store,
    private router: Router,
    public loadingService: LoadingService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loadingService.show();
    this.store.dispatch(AuthActions.logout());
  }
}
